<template>
  <template-booking-detail-page></template-booking-detail-page>
</template>

<script lang="ts">

import templateBookingDetailPage from '@/app-template/lib/pages/BookingDetailPage.vue';

export default {
  name: "BookingDetailPage",
  components: { templateBookingDetailPage },
};
</script>